import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("gc_lang") || "en");

  useEffect(() => {
    localStorage.setItem("gc_lang", lang);
    document.documentElement.lang = lang;
    if (lang === "hi") {
      document.body.classList.add("font-hindi");
      document.body.classList.remove("font-eng");
    } else {
      document.body.classList.add("font-eng");
      document.body.classList.remove("font-hindi");
    }
  }, [lang]);

  const t = translations[lang];
  const toggle = () => setLang((l) => (l === "en" ? "hi" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
